import React, { useState, useEffect, act } from 'react';
import Loader from '../../../../presentationals/Loader/Loader.component';
import moment from 'moment';
import { Pagination } from '@mui/material';
import { getMonthLeadFlowByApplyDateStats, getMonthLeadFlowByApplyDateDeptStats, getMonthLeadFlowByApplyDateData, getMonthLeadFlowByApplyDateDEPTData } from '../../AdminActionCreator.component';

const itemsPerPage = 15;


export default function AssignedLeadCountNew({ userDetailHandler }) {

    const [loader, setLoader] = useState(false);
    const [payload, setPayload] = useState({
        fromDate: moment(new Date()).format("YYYY-MM-DD"),
        toDate: moment(new Date()).format("YYYY-MM-DD"),
        category: '',
        subcategory: '',

    });
    const [activeTab, setActiveTab] = useState('level1')
    const [tabDataFirst, setTabDataFirst] = useState({});
    const [paginatedData, setpaginatedData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1)
    const [tableData, setTableData] = useState([])
    const [totalPages, settotalPages] = useState(1)



    useEffect(() => {
        APISHanlde();
    }, []);

    const APISHanlde = () => {
        const obj = {
            fromDate: payload?.fromDate,
            toDate: payload?.toDate,
            category: '',
            subcategory: '',

        }

        setTableData([])
        setpaginatedData([])
        setPayload(obj)
        if (activeTab == "level1") {
            getMonthLeadFlowByApplyDateStatsFn(obj);
        } else if (activeTab == "level2") {
            getMonthLeadFlowByApplyDateDeptStatsFn(obj)
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleTabs = (type) => {
        setActiveTab(type)
        setPayload((prev) => ({
            ...prev,
            category: '',
            subcategory: '',
        }));
        setTabDataFirst([])
        setpaginatedData([])
        if (type == "level1") {
            getMonthLeadFlowByApplyDateStatsFn(payload);
        } else if (type == "level2") {
            getMonthLeadFlowByApplyDateDeptStatsFn(payload)
        }
    }

    const getMonthLeadFlowByApplyDateStatsFn = (data) => {
        const start = moment(data?.fromDate).format("DD-MM-YYYY");
        const end = moment(data?.toDate).format("DD-MM-YYYY");
        setLoader(true);
        getMonthLeadFlowByApplyDateStats(start, end, callback => {
            setLoader(false);
            if (callback?.status == 200 && callback?.message == "success") {
                setTabDataFirst(callback?.data);
            } else {
                setTabDataFirst({});
            }
        });

    };
    const getMonthLeadFlowByApplyDateDeptStatsFn = (data) => {
        const start = moment(data?.fromDate).format("DD-MM-YYYY");
        const end = moment(data?.toDate).format("DD-MM-YYYY");
        setLoader(true);
        getMonthLeadFlowByApplyDateDeptStats(start, end, callback => {
            setLoader(false);
            if (callback?.status == 200 && callback?.message == "success") {
                setTabDataFirst(callback?.data);
            } else {
                setTabDataFirst({});
            }
        });

    };

    const handlePagination = (e, value) => {
        setcurrentPage(value)
        PaginationFn(value, tableData)
    }

    const PaginationFn = (currentPage, totalData) => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedData = totalData?.length > 0 ? totalData?.slice(startIndex, endIndex) : [];
        setpaginatedData(paginatedData)
    }


    const handleTabSelect = (value, key) => {
        setPayload((prev) => ({
            ...prev,
            "category": value,
            "subcategory": key
        }))
        const categorynew = value == "total" ? "" : value

        if (activeTab == "level1") {
            getMonthLeadFlowByApplyDateDataFn(payload, categorynew, key)
        } else if (activeTab == "level2") {
            getMonthLeadFlowByApplyDateDEPTDataFn(payload, categorynew, key)
        }
    }


    const getMonthLeadFlowByApplyDateDataFn = (data, category, subcategory) => {
        const start = moment(data?.fromDate).format("DD-MM-YYYY");
        const end = moment(data?.toDate).format("DD-MM-YYYY");
        setLoader(true);
        getMonthLeadFlowByApplyDateData(start, end, category, subcategory, callback => {
            console.log(":ca", callback)
            setLoader(false)
            if (callback?.message == "success" && callback?.status == 200 && callback?.data?.length > 0) {
                setcurrentPage(1)
                setTableData(callback?.data)
                PaginationFn(1, callback?.data)
                settotalPages(callback?.data?.length)

            } else {
                setTableData([])
                setpaginatedData([])
                settotalPages(1)
            }
        })
    }
    const getMonthLeadFlowByApplyDateDEPTDataFn = (data, category, subcategory) => {
        const start = moment(data?.fromDate).format("DD-MM-YYYY");
        const end = moment(data?.toDate).format("DD-MM-YYYY");
        setLoader(true);
        getMonthLeadFlowByApplyDateDEPTData(start, end, category, subcategory, callback => {
            console.log(":ca", callback)
            setLoader(false)
            if (callback?.message == "success" && callback?.status == 200 && callback?.data?.length > 0) {
                setcurrentPage(1)
                setTableData(callback?.data)
                PaginationFn(1, callback?.data)
                settotalPages(callback?.data?.length)

            } else {
                setTableData([])
                setpaginatedData([])
                settotalPages(1)
            }
        })
    }

    const handleName = (type) => {
        if (type == "total") {
            return "Total"
        } else if (type == "new") {
            return "New"
        } else if (type == "INCOMPLETE") {
            return "Incomplete"
        } else if (type == "PARTIAL_COMPLETE") {
            return "Partial Complete"
        } else if (type == "customerService") {
            return "Customer Service"
        } else if (type == "COMPLETE") {
            return "Complete"
        } else if (type == "credit") {
            return "Credit"
        } else if (type == "repeat" || type == "REPEAT") {
            return "Repeat"
        }
    }


    return (
        <>
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                {loader ? <Loader /> : ""}

                <div className="row">
                    <div className="col-sm-2 col-xs-6">
                        <label htmlFor="fromDate" style={{ color: '#333', fontWeight: '500' }}>Start Date</label>
                        <input
                            type="date"
                            id="fromDate"
                            className='form-control'
                            value={payload?.fromDate}
                            name="fromDate"
                            onChange={(e) => handleChange(e)}
                            style={{ borderRadius: '8px', border: '1px solid #D3D3D3' }}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <label htmlFor="toDate" style={{ color: '#333', fontWeight: '500' }}>End Date</label>
                        <input
                            type="date"
                            id="toDate"
                            className='form-control'
                            value={payload?.toDate}
                            min={payload?.fromDate}
                            name="toDate"
                            onChange={(e) => handleChange(e)}
                            style={{ borderRadius: '8px', border: '1px solid #D3D3D3' }}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <button
                            className='btn btn-primary'
                            style={{ padding: '10px 20px', marginTop: '22px' }}
                            onClick={() => APISHanlde()}
                        >
                            Filter
                        </button>
                    </div>
                    <div className="col-sm-3 col-xs-6" style={{ float: 'right', textAlign: 'right' }}>
                        <div style={{ display: 'inline-flex', background: 'rgb(219, 233, 255)', padding: '10px', borderRadius: '4px', marginTop: '13px' }}>
                            <button
                                className={`btn-tab-white ${activeTab == 'level1' ? "active" : ""}`}
                                style={{ borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px', padding: '10px 15px' }}
                                onClick={() => handleTabs('level1')}
                            >
                                Level 1
                            </button>
                            <button
                                className={`btn-tab-white ${activeTab == 'level2' ? "active" : ""}`}
                                style={{ borderTopRightRadius: '4px', borderBottomRightRadius: '4px', padding: '10px 15px' }}
                                onClick={() => handleTabs('level2')}
                            >
                                Level 2
                            </button>
                        </div>
                    </div>
                </div>



                <div className='row' style={{ marginTop: '25px' }}>
                    <div className="col-sm-3 col-xs-12">
                        <div className="LMCountclass" style={{ marginTop: '20px' }}>
                            {
                                tabDataFirst && Object.keys(tabDataFirst)?.length > 0 ?
                                    Object.keys(tabDataFirst)?.map((value, id) => {
                                        const isLastGroup = id === Object.keys(tabDataFirst).length - 1;
                                        return (
                                            <>
                                                <div className="topBox" >
                                                    {value}
                                                </div>
                                                {
                                                    Object.keys(tabDataFirst?.[value]) != null && Object.keys(tabDataFirst?.[value])?.length > 0 ?
                                                        Object.entries(tabDataFirst?.[value])?.map(([key, value2], index) => {
                                                            const isLastItem = index === Object.entries(tabDataFirst?.[value]).length - 1;
                                                            const isLastOfAll = isLastGroup && isLastItem;
                                                            return (
                                                                <div className={`subBoxTop ${isLastOfAll ? 'lastItem' : ''}`}>
                                                                    <div className={`subBox ${payload?.category == value && payload?.subcategory == key ? "active" : ""}`} onClick={() => handleTabSelect(value, key)}>
                                                                        {handleName(key)} : {value2}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        <div className={`subBoxEmpty ${isLastGroup ? "lastItem" : ""}`}>

                                                        </div>
                                                }
                                            </>
                                        )
                                    })
                                    : ''}

                        </div>
                    </div>
                    <div className="col-sm-9 col-xs-12">


                        {
                            paginatedData && paginatedData?.length > 0 ?
                                <div style={{ boxShadow: '5px 5px 10px 5px #cfcfcf', borderRadius: '12px', padding: '15px', marginBottom: '10px', marginTop: '20px' }}>
                                    <div className='overflow-x-auto phocket-table-new' >
                                        <table className=''>
                                            <thead>
                                                <tr>

                                                    <th className='text-center'>Currently Assigned</th>
                                                    <th className='text-center'>Details</th>
                                                    <th className='text-center' style={{ minWidth: '150px' }}>Application Id</th>
                                                    <th className='text-center'>Name</th>
                                                    <th className='text-center'>Assigned At</th>
                                                    <th className='text-center'>Loan Amount</th>
                                                    <th className='text-center'>Loan Status</th>

                                                    <th className='text-center'>Touched On</th>
                                                    <th className='text-center'>Completed On</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paginatedData?.map((v, id) => {
                                                        if (id == 0) {
                                                            console.log(v)
                                                        }
                                                        return (
                                                            <tr key={id}>

                                                                <td className='text-center' style={{ background: v?.currentlyAssigned == true ? "#19d71959" : '#f03d3d99' }}>{v?.currentlyAssigned == true ? "Yes" : "No"}</td>
                                                                <td className='text-center'>
                                                                    <i className='fa fa-info' onClick={() => userDetailHandler(v)}></i>
                                                                </td>
                                                                <td className='text-center'>{v?.applicationId}</td>
                                                                <td className='text-center'>{v?.name}</td>
                                                                <td className='text-center'>{v?.assignedAt}</td>
                                                                <td className='text-center'>{v?.loanAmount}</td>
                                                                <td className='text-center'>{v?.loanStatus}</td>
                                                                <td className='text-center'>{v?.touchedOn}</td>
                                                                <td className='text-center'>{v?.completedOn}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ marginBottom: '15px', marginTop: '15px', display: 'flex', marginRight: '20px', justifyContent: 'end' }}>
                                        <Pagination size='large' onChange={(e, value) => handlePagination(e, value)} color="primary"
                                            count={Math.ceil(totalPages / itemsPerPage)}
                                            page={currentPage || 1} />
                                    </div>
                                </div>
                                : ""}

                    </div>
                </div>
            </div>
        </>
    );
}
